export default '/build/6803a0da.svg'